import * as React from "react";
import {CardHeader} from 'material-ui';
import * as moment from 'moment'
import AvatarPlus from '../common/AvatarPlus';

const Title = ({userName}) => {
    const href = `/user/${userName}`;
    return <a href={href}>{userName}</a>;
};

interface ISongCardHeaderProps
{
    songCreatedAt: string,
    songViews: number,
    songAuthorPicture?: string,
    songAuthorUsername: string

}

class SongCardHeader extends React.Component<ISongCardHeaderProps, any> {


    //noinspection JSMethodCanBeStatic
    render() {
        const createdAtHumanReadable = this.humanizeDate(this.props.songCreatedAt);
        const viewsHumanReadable = this.humanizeNumber(this.props.songViews, 1);

        return (
            <CardHeader
                title={<Title userName={this.props.songAuthorUsername}/>}
                subtitle={`${createdAtHumanReadable} ago • ${viewsHumanReadable} views`}
                avatar={
                    <AvatarPlus
                        size={60}
                        src={this.props.songAuthorPicture}
                        style={{marginRight: '0.5em'}}
                    />
                }
            />
        )
    }

    //noinspection JSMethodCanBeStatic
    humanizeDate(dateTime) {
        const songCreation = moment.utc(dateTime);
        const howLongAgoUtc = moment.utc() - songCreation;
        return moment.duration(howLongAgoUtc).humanize();
    }

    //noinspection JSMethodCanBeStatic
    humanizeNumber(num, digits) {
        const units = ['k', 'M', 'B', 'T', 'P', 'E', 'Z', 'Y'];
        let decimal;

        for (let i = units.length - 1; i >= 0; i--) {
            decimal = Math.pow(1000, i + 1);

            if (num <= -decimal || num >= decimal) {
                return +(num / decimal).toFixed(digits) + units[i];
            }
        }
        return num;
    };

}

export default SongCardHeader;


// WEBPACK FOOTER //
// ./components/songs/SongCardHeader.tsx